import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";

export interface ShopOperatorService {
    getShopOperator(shopId: string, startDate: Date, endDate: Date): angular.IPromise<apsViewModels.ShopOperatorType>;
}

class ShopOperatorServiceImpl implements ShopOperatorService {
    private httpService: HttpService;

    constructor(httpService: HttpService) {
        this.httpService = httpService;
    }

    getShopOperator(shopId: string, startDate: Date, endDate: Date): angular.IPromise<apsViewModels.ShopOperatorType> {
        return this.httpService.get(
            Endpoints.SHOP_OPERATOR_DASHBOARD,
            {
                shopId: shopId,
                startDate: startDate,
                endDate: endDate
            });
    }
}

export default angular
    .module('aps.services.shopOperatorService', [HttpServiceName])
    .service('shopOperatorService', ShopOperatorServiceImpl)
    .name;


// WEBPACK FOOTER //
// ./src/app/services/dashboard/shopOperator.service.ts